import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';

// Material components
import { Grid, Typography } from '@material-ui/core';

const useStyles = makeStyles({
    alignCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    alignLeft: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center'
    },
});

export function SmallFormContainer(props) {

    const classes = useStyles();

    return (
        <Fragment>
            <Grid item xs={4} sm={4} className={classes.alignLeft}>
                <Typography variant="body1" >{props.labelText}:</Typography>
            </Grid>
            <Grid item xs={8} sm={8} className={classes.alignCenter}>
                {props.children}
            </Grid>
        </Fragment>
    );
}